/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";

//Material
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";

//Style
import { StyledTableCell, StyledTableRow } from "./style";
import { setOptimalSolutionLccData } from "store/slices/lcc_slice";
import { deserializeOptimalSolutionLccData } from "utils/deserializers/lcc_data_deserializer";
import { useDispatch, useSelector } from "react-redux";

function createData(name, filterType, filterEfficieny, sizeConstraints) {
  return { name, filterType, filterEfficieny, sizeConstraints };
}

const rows = [
  createData("Filter Type", "Static", "Pulse", "Static"),
  createData("Filter efficiency", "T5", "T8", "T8"),
  createData(
    "Size Constraints",
    '200mm[7.9"] to 350mm[13.8"]',
    '350mm[13.8"] to 600mm[23.6"]',
    '> 700mm[27.6"]'
  ),
];

function OptimalTable() {
  const dispatch = useDispatch();

  const { globalOptimalSolution } = useSelector((state) => state.filters);
  const { optimalSolution } = useSelector((state) => state.lccData);

  useEffect(() => {
    dispatch(
      setOptimalSolutionLccData(
        deserializeOptimalSolutionLccData(globalOptimalSolution.filter)
      )
    );
  }, [globalOptimalSolution]);

  const rows = useMemo(() => {
    const data = [["Filter Type"], ["Filter Efficiency"], ["Size Constraints"]];
    optimalSolution?.data?.forEach((item, index) => {
      data[0].push(item.filterType);
      data[1].push(item.filterEfficiency);
      data[2].push(item.sizeConstraints);
      return "";
    });
    return data;
  }, [optimalSolution]);

  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table">
        <TableHead>
          <StyledTableRow>
            <StyledTableCell
              colSpan={5}
              align="center"
              isFirstRow
              sx={{ textTransform: "uppercase" }}
            >
              Optimal Solution
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow className="second-table-head-row">
            <StyledTableCell>
              Number of Stages: {optimalSolution.numberOfStages}
            </StyledTableCell>
            {optimalSolution?.data?.map((item, index) => {
              return (
                <StyledTableCell key={item.name} align="center">
                  {item.name}
                </StyledTableCell>
              );
            })}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row, index) => (
            <StyledTableRow key={row?.[0]} isFirstRow={index === 0}>
              {row.map((item, innerIndex) => {
                return (
                  <StyledTableCell
                    key={item}
                    component="th"
                    scope="row"
                    isFirstChild={innerIndex === 0}
                  >
                    {item}
                  </StyledTableCell>
                );
              })}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default OptimalTable;
